import React, { useState } from 'react';
import { Box } from '@mui/material';
import Header from '../../Common/Header/Header';
import ServicesWrapper from '../Common/Services/page';
import { QUERY_KEYS_SIH } from '../../Common/hooks/useChartsData';
import { subtitlesMap } from '../Common/maps/subtitleMap';
import ProceduresList from './ProceduresLists/ProceduresLists';
import ChartsContainer from '../../Common/ChartsContainer';

const titleMap = {
    0: 'Tipo de VDRL',
    1: 'Gestação com Risco',
    2: 'Infecção Hospitalar',
    3: 'Ranking'
};

const renderContent = (activeIndex) => {
    switch (activeIndex) {
        case 0:
            return (
                <ServicesWrapper
                    module={{ sectionTitle: 'do Tipo de VDRL' }}
                    queryConfig={{
                        key: QUERY_KEYS_SIH.IND_VDLR,
                        url: 'governanceroom/dashboard/sihsus/aih/vdrl'
                    }}
                    subtitlesMap={subtitlesMap}
                />
            );
        case 1:
            return (
                <ServicesWrapper
                    module={{ sectionTitle: 'do Gestação com Risco' }}
                    queryConfig={{
                        key: QUERY_KEYS_SIH.PREGANT,
                        url: 'governanceroom/dashboard/sihsus/aih/pregnantRisk'
                    }}
                    subtitlesMap={subtitlesMap}
                />
            );
        case 2:
            return (
                <ServicesWrapper
                    module={{ sectionTitle: 'do Infecção Hospitalar' }}
                    queryConfig={{
                        key: QUERY_KEYS_SIH.HOSPITAL_INFECTION,
                        url: 'governanceroom/dashboard/sihsus/aih/hospitalarInfection'
                    }}
                    subtitlesMap={subtitlesMap}
                />
            );
        case 3:
            return <ProceduresList />;
        default:
            return null;
    }
};

export const Procedures = ({ setActiveIndex }) => {
    const [activeIndexLocal, setActiveIndexLocal] = useState(0);

    const handleHomeClick = () => {
        if (setActiveIndex) {
            setActiveIndex(0);
        }
        setActiveIndexLocal(0);
    };

    const menus = [
        {
            title: 'VDRL',
            onclick: () => setActiveIndexLocal(0),
            active: activeIndexLocal === 0
        },
        {
            title: 'Gestação com Risco',
            onclick: () => setActiveIndexLocal(1),
            active: activeIndexLocal === 1
        },
        {
            title: 'Infecção Hospitalar',
            onclick: () => setActiveIndexLocal(2),
            active: activeIndexLocal === 2
        },
        {
            title: 'Ranking',
            onclick: () => setActiveIndexLocal(3),
            active: activeIndexLocal === 3
        }
    ];

    return (
        <Box className="producao-container">
            <Header menus={menus} onHomeClick={handleHomeClick} />
            <Box>
                <ChartsContainer
                    title={titleMap[activeIndexLocal]}
                    className="services-container-dashboards"
                >
                    {renderContent(activeIndexLocal)}
                </ChartsContainer>
            </Box>
        </Box>
    );
};